import { jsx as _jsx } from "react/jsx-runtime";
import withStyles from '../withStyles';
import styles from './MenuTitle.styles';
export const MenuTitle = ({ label, classes }) => (_jsx("div", Object.assign({ className: classes.root }, { children: label })));
export default withStyles(styles)(MenuTitle);
//# sourceMappingURL=MenuTitle.js.map